var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuffs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 49.8302L24.0567 31.7735C32.5834 31.272 40.1071 36.2877 45.3736 46.0684",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8059 31.7738C23.8059 31.5732 36.8468 14.8039 43.3673 6.44434",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.574 32.0246C31.4337 28.9336 32.6537 27.5279 35.0913 25.5042",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8721 44.5642C51.4197 37.2563 56.0296 34.4116 63.1795 27.7615C56.7555 35.537 53.097 39.814 45.6244 46.0689",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3799 50.3322C49.8279 48.5228 51.1539 47.4695 52.8972 45.0657",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3799 56.8527C49.773 56.6584 66.9308 40.3958 74.4649 31.5232",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5738 62.1193L31.3294 60.3638C34.3491 66.1398 34.8406 69.3924 31.3294 73.6558C20.0442 76.916 2.99035 56.1 6.50147 49.5796C10.5143 45.5671 19.3693 48.7308 29.5738 62.1193Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3737 46.3196L31.3296 60.3637C33.2366 64.1292 33.6648 66.6434 33.5867 71.6491L47.6308 56.8526C48.1157 51.9141 47.6034 49.5983 45.3737 46.3196Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1319 51.2056C31.8281 51.9429 30.8261 52.3873 29.7858 51.9588C28.7454 51.5303 28.347 50.5091 28.6507 49.7717C28.9544 49.0343 29.9565 48.59 30.9968 49.0185C32.0371 49.447 32.4356 50.4682 32.1319 51.2056Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.2992,
    y: 47.9834,
    width: 0.250787,
    height: 8.36908,
    transform: "rotate(-45 27.2992 47.9834)",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.250787
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuffs);
export default __webpack_public_path__ + "static/media/cuffs.8fa45423e2aeea3d5e079c242e5fbcf7.svg";
export { ForwardRef as ReactComponent };